import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectUserCollection, selectUsers } from '../state-example/state/users.selectors';
import { UsersActions, UsersApiActions } from '../state-example/state/users.actions';
import { UsersService } from '../state-example/user-list/users.service';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss'
})
export class TestComponent {

  users$ = this.store.select(selectUsers);
  userCollection$ = this.store.select(selectUserCollection);

  onAdd(userId: string) {
    this.store.dispatch(UsersActions.addUser({ userId }));
  }

  onRemove(userId: string) {
    this.store.dispatch(UsersActions.removeUser({ userId }));
  }

  constructor(private usersService: UsersService, private store: Store) {}

  ngOnInit() {
    this.usersService
      .getUsers()
      .subscribe((users) =>
        this.store.dispatch(UsersApiActions.retrievedUserList({ users }))
      );
  }

}
